"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var KsysRequest_1 = require("../KsysRequest");
var RetrieveClientConfiguration = /** @class */ (function (_super) {
    __extends(RetrieveClientConfiguration, _super);
    function RetrieveClientConfiguration() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getExplicitEndpoint = function () { return '/config/retrieveClientConfiguration'; };
        return _this;
    }
    Object.defineProperty(RetrieveClientConfiguration.prototype, "endpointConfiguration", {
        get: function () {
            return this.getEndpointConfiguration("config", "RetrieveClientConfiguration");
        },
        enumerable: true,
        configurable: true
    });
    return RetrieveClientConfiguration;
}(KsysRequest_1.KsysRequest));
exports.RetrieveClientConfiguration = RetrieveClientConfiguration;
//# sourceMappingURL=RetrieveClientConfiguration.js.map